import { render, staticRenderFns } from "./UserActivation.vue?vue&type=template&id=70b44508&scoped=true"
import script from "./UserActivation.vue?vue&type=script&lang=js"
export * from "./UserActivation.vue?vue&type=script&lang=js"
import style0 from "./UserActivation.vue?vue&type=style&index=0&id=70b44508&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70b44508",
  null
  
)

export default component.exports